module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-orange-d7f831f7d5d4d5e17c437c289b59328a.svg";